'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _OMPublishButton = require('./OMPublishButton.scss');var _OMPublishButton2 = _interopRequireDefault(_OMPublishButton);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMPublishButton = function OMPublishButton(properties) {var _cx;return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_OMPublishButton2.default.publishBtn, (_cx = {}, _cx[_OMPublishButton2.default.foreignPublishBtn] = properties.isForein, _cx)) },
      _react2.default.createElement('button', { className: _OMPublishButton2.default.button, onClick: properties.publishProperty }),
      _react2.default.createElement('span', null, properties.translate('publish'))));};exports.default =



OMPublishButton;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPublishButton/OMPublishButton.js
// module id = 2757
// module chunks = 0